import { property } from 'lodash';
import React from 'react';
import ProductReview from './ProductReview';
class ProductExtraDetail extends React.Component {
    handleShowForm = (flag)=>{
        this.props.handleShowForm(flag);
    }
    
    render() {
        let {product,showContent, account} = this.props,
        content = '';
        if(showContent === 'field')
        {
            content = product.field.length ? 
            product.field.map((field, index)=>{
                if(field.value){
                    return (
                        <tr key={index}>
                            <td>{field.title}</td>
                            <td>{field.value}</td>
                        </tr>
                    );
                }
                return null;
            })
            :null;
            content = 
            <div className="row">
                <div className="col-12 col-md-6 col-lg-5">
                    <div className="table-responsive">
                        <table className="table w-100 table-borderless mt-4">
                            <tbody>
                            {content}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col-md-6 col-lg-7 d-none d-md-block ">
                    <img src={product.info.image} alt={product.info.title} style={{maxWidth:'40%'}} className="img-fluid mx-auto d-block" />
                </div>
                <div className="col-12 mb-2"><hr/></div>
                <div className="col-12">
                   <div className="product-col-detail p-2" dangerouslySetInnerHTML={{__html: product.info.body}}/>
                </div>
            </div>
        }
        else if(showContent === 'review')
        {
            content = 
            <ProductReview isShowForm={this.props.isShowForm} handleShowForm={this.handleShowForm} 
            product={product} account={account} />
        }
        return (
            <div>
                {content}
            </div>
        )
    }
}
export default ProductExtraDetail;